import { IRoot } from '@state/types'

export function useDocumentTitle({ currentRundown, currentScript }: IRoot) {
  const currentTitle = currentScript?.name ?? currentRundown?.name ?? 'Scripto'
  document.title = currentTitle
}
